__turbopack_context__.v({
  "fixedMenu": "ObserverList-module-scss-module__8cquvG__fixedMenu",
  "fixedMenuVisible": "ObserverList-module-scss-module__8cquvG__fixedMenuVisible",
  "item": "ObserverList-module-scss-module__8cquvG__item",
  "itemActive": "ObserverList-module-scss-module__8cquvG__itemActive",
  "itemImage": "ObserverList-module-scss-module__8cquvG__itemImage",
  "itemLabel": "ObserverList-module-scss-module__8cquvG__itemLabel",
  "itemWithImage": "ObserverList-module-scss-module__8cquvG__itemWithImage",
  "itemWithImageActive": "ObserverList-module-scss-module__8cquvG__itemWithImageActive",
  "list": "ObserverList-module-scss-module__8cquvG__list",
  "listWithImages": "ObserverList-module-scss-module__8cquvG__listWithImages",
  "root": "ObserverList-module-scss-module__8cquvG__root",
});
